export const cartCommon = {
  label: {
    name: 'Nom',
    number: 'Numéro',
    status: 'Statut',
    requestedDeliveryDate: 'Date de livraison demandée',
    customerPO: 'Bon de commande du client',
    jobNameNumber: 'Nom / Numéro du travail',
    shipComplete: 'Expédier en totalité',
    headerNotes: 'Instruction spéciale',
    referenceCart: 'Brouillon de commande de référence',
    createdBy: 'Créé par',
    createdDate: 'Date de création',
    lastUpdatedDate: 'Date de dernière mise à jour',
    submitForApproval: 'Soumettre pour approbation',
    checkout: 'Passer la commande',
    totalItems: "Nombre total d'articles :",
    totalQuantity: 'Quantité totale :',
    totalPrice: 'Prix total :',
    itemDetails: "Détails de l'article",
    productDetails: 'Détails du produit',
    plant: 'Usine',
    requestedShipDate: "Date d'expédition demandée",
    listPrice: 'Prix de liste',
    netPrice: 'Prix net',
    quantity: 'Quantité',
    total: 'Total',
    priceAdjustment: 'Ajustement de prix',
    quoteReference: 'Référence de la soumission',
    uom: 'Unité de mesure',
    moq: 'QMC (Quantité minimale de commande)',
    actions: 'Actions',
    cart: 'Panier',
    downloadPDF: 'Télécharger le PDF',
    createdOn: 'Créé le',
    saveUpdatedCart: 'Sauvegarder le panier mis à jour',
    lineNo: 'N° de ligne',
    productAvailability: 'Disponibilité du produit',
    specialInstructions: 'Instructions spéciales',
    atgDivision: 'Division ATG',
    leadTime: 'Délai de traitement',
    deliveryUnitAdjusted: 'La quantité de la commande doit être un multiple de l\'unité de livraison {{ unit }}',
    moqAdjusted: 'La quantité de la commande doit être supérieure ou égale à la quantité minimale de commande.',
    priceNotAvailable: '« Prix non disponible »',
    priceNotAvailableMessage: 'Ce produit ne peut pas être ajouté à votre panier pour le moment.',
    srNo: 'Article de la commande',
    removeDisabledProducts: 'Selectionner les produits desactives',
    disabledProductsFound: '{{count}} produit(s) desactive(s) trouve(s)',
    updateNetPriceLink: 'Obtenir mon prix',
  },
  createMessage: {
    success: 'Le brouillon de commande a été créé avec succès.',
    error: 'Une erreur est survenue lors de la création du brouillon de commande.',
  },
  copyMessage: {
    success: 'Le brouillon de commande a été copié avec succès.',
    error: 'Une erreur est survenue lors de la copie du brouillon de commande.',
  },
  updateMessage: {
    success: 'Le brouillon de commande a été mis à jour avec succès.',
    error: 'Une erreur est survenue lors de la mise à jour du brouillon de commande.',
    pricingUpdateError: 'Impossible de mettre a jour le prix pour le moment. Veuillez reessayer.',
  },
  deleteMessage: {
    success: 'Le brouillon de commande a été supprimé avec succès.',
    error: 'Une erreur est survenue lors de la suppression du brouillon de commande.',
  },
  invalidQtyMessage: {
    entryMessage: 'Veuillez saisir une quantité valide (multiple de la QMC) pour cet article',
    globalMessage: 'Veuillez saisir une quantité valide (multiple de la QMC) pour les numéros de ligne {{ linenos }}',
  },
  commentMessage: {
    isGenericGlobalMessage:
      "Pour le(s) produit(s) : {{ linenos }}, veuillez remplir le champ obligatoire (feuille de travail d'arc, n° de plan ou commentaires)",
    isSinkPatternGlobalMessage:
      'Pour le(s) produit(s) : {{ linenos }}, vous devez choisir la configuration de perçage requise dans le menu déroulant.',
  },
  referenceRemovedMessage: 'La référence de la soumission a été mise à jour avec succès.',
  validation: {
    purchaseOrderNumber: {
      maxlength: 'Le bon de commande du client ne peut pas dépasser 25 caractères',
      pattern: 'Le bon de commande du client ne peut pas contenir de caractères spéciaux',
    },
  },
};
export const cartSearchForm = {
  label: {
    draftOrderName: 'Nom',
    accountNumber: 'Numéro de compte',
    accountName: 'Nom du compte',
    customerPO: 'Bon de commande du client',
    jobNameNumber: 'Nom / Numéro du travail',
    status: 'Statut',
    draftOrderNumber: 'Numéro',
  },
};
export const cartResult = {
  header: {
    draftOrderNumber: 'Numéro',
    draftOrderName: 'Nom',
    createdBy: 'Créé par',
    creationDate: 'Date de création',
    createdOn: 'Créé le',
    accountNo: 'N° de compte',
    accountName: 'Nom du compte',
    customerPO: 'Bon de commande du client',
    jobNameNumber: 'Nom / Numéro du travail',
    status: 'Statut',
    total: 'Total',
    actions: 'Actions',
    job: 'Travail',
    updateBy: 'Mis à jour par',
  },
  nodataMsg: 'Les brouillons de commande apparaîtront ici une fois qu\'ils auront été créés et enregistrés.',
  showMore: 'Afficher plus',
};
export const addToCartMessage = {
  success: 'Les produits ont été ajoutés au brouillon de commande avec succès.',
  failure: "Échec de l'ajout des produits au brouillon de commande.",
};
